import { combineReducers } from '@reduxjs/toolkit';

import { bodyType } from './bodyType';
import { characteristic } from './characteristic';
import { mark } from './mark';
import { model } from './model';
import { modification } from './modification';
import { type } from './type';
import { techData } from './techData';

export default combineReducers({
    type,
    mark,
    model,
    modification,
    bodyType,
    characteristic,
    techData,
});
